import { Event } from '../../../base/common/events.js';
import type { ILicenseService } from '../common/licenses.js';

/** The standalone agent preview grants no paid Inspector entitlement. */
export class PreviewLicenseService implements ILicenseService {
    readonly _serviceBrand: undefined;
    readonly onDidChange: Event<ILicenseService> = Event.None;

    get licenses() { return null; }
    getLicenses() { return Promise.resolve([]); }
    hasInspectorLicense() { return Promise.resolve(false); }
    get isInspectorLicensed() { return null; }
    get isInspectorAccessAllowed() { return false; }
    get inspectorAccessReason() { return null; }
    refreshInspectorAccess() { return Promise.resolve(); }
    refresh() { return Promise.resolve([]); }
    getPurchaseUrl() { return null; }
    getCheckoutUrl() { return Promise.resolve(null); }
    getPurchaseInfo() { return Promise.resolve(null); }
}
